export default "__VITE_ASSET__D4z3FCEi__"